import { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';

export const QR = ({ data, centerImageSrc, width = 120, height = 120 }) => {
  const qrRef = useRef(null);
  const qrInstance = useRef(null);

  useEffect(() => {
    const pixelRatio = window.devicePixelRatio || 1;

    qrInstance.current = new QRCodeStyling({
      width: width * pixelRatio,
      height: height * pixelRatio,
      data,
      margin: 4,
      dotsOptions: {
        type: 'rounded',
        color: 'white',
      },
      cornersSquareOptions: {
        type: 'extra-rounded',
        color: 'white',
      },
      backgroundOptions: {
        color: 'transparent',
      },
      errorCorrectionLevel: 'L',
    });

    if (qrRef.current) {
      qrInstance.current.append(qrRef.current);

      // Ensure canvas style matches exactly
      requestAnimationFrame(() => {
        const canvas = qrRef.current.querySelector('canvas');
        if (canvas) {
          canvas.style.width = `${width}px`;
          canvas.style.height = `${height}px`;
          canvas.style.display = 'block'; // 🚀 no extra space
        }
      });
    }
  }, []);

  useEffect(() => {
    const image = {
      image: centerImageSrc,
      imageOptions: { crossOrigin: 'anonymous', margin: 4 },
      imageSize: 1,
    };
    const pixelRatio = window.devicePixelRatio || 1;
    qrInstance.current?.update({
      data,
      width: width * pixelRatio,
      height: height * pixelRatio,
      ...image,
    });
  }, [centerImageSrc, data, width, height]);

  return (
    <div
      ref={qrRef}
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
    />
  );
};
